var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50224 8.7763C7.08572 9.96917 8.05266 10.9317 9.24818 11.5098C9.33565 11.5512 9.4324 11.5692 9.52892 11.5619C9.62544 11.5546 9.71839 11.5222 9.79863 11.4681L11.559 10.2943C11.6368 10.2424 11.7264 10.2107 11.8196 10.2021C11.9127 10.1936 12.0066 10.2084 12.0926 10.2453L15.3858 11.6566C15.4977 11.7042 15.5911 11.7868 15.652 11.892C15.7128 11.9972 15.7378 12.1193 15.7232 12.24C15.6191 13.0545 15.2217 13.8031 14.6054 14.3457C13.9891 14.8883 13.1961 15.1877 12.375 15.1877C9.83887 15.1877 7.40661 14.1802 5.61329 12.3869C3.81997 10.5936 2.8125 8.16135 2.8125 5.62522C2.81254 4.80409 3.11189 4.01114 3.65448 3.39482C4.19707 2.77851 4.94571 2.3811 5.76021 2.27701C5.88088 2.26241 6.00302 2.28742 6.10824 2.34827C6.21346 2.40912 6.29605 2.50251 6.34357 2.61439L7.75619 5.91049C7.79272 5.99574 7.80761 6.08871 7.79952 6.18111C7.79144 6.27352 7.76062 6.36249 7.70983 6.4401L6.54008 8.22742C6.48684 8.30783 6.45537 8.40066 6.44874 8.49687C6.4421 8.59307 6.46054 8.68935 6.50224 8.7763V8.7763Z",
    stroke: "#1E1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.a4c3d8e1f2e2f7b8a94c85c048a49b60.svg";
export { ForwardRef as ReactComponent };